import { Component, inject, signal } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { firstValueFrom, switchMap, tap } from 'rxjs'
import { SpinnerComponent } from '../../spinner/spinner.component'
import { FilterService } from 'src/app/shared/services/filter/filter.service'
import { ActiveFilterListComponent } from '../../table/filters/active-filter-list/active-filter-list.component'
import { ServicePointManagementService } from '../../service-point-management/service-point-management.service'

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    ActiveFilterListComponent,
    SpinnerComponent,
  ],
  selector: 'app-export-service-point-overrides-modal',
  styles: `
    div.loading {
      margin-top: 3rem;
    }

    .spinner-anchor {
      position: absolute;
      left: 50%;
      top: -3rem;
    }

    .warn {
      color: goldenrod;
    }

    .error {
      color: red
    }
  `,
  template: `
    <div app-modal-header>Export Service Point Overrides</div>
    <div app-modal-body [class.loading]="loading()">
      @if(loading()) {
        <span class="spinner-anchor">
          <app-spinner />
        </span>
      } @else {
        <app-active-filter-list [filterGroup]="filterGroup()" [filterName]="filtersToShow()" />
      }
      <span class="warn">
        If you are exporting a large data set, it could take some time. Please
        be patient and do not refresh the page until the data has been
        downloaded
      </span>
    </div>
    <div app-modal-footer>
      <button class="action-btn" (click)="onCancel()">Cancel</button>
      <button
        class="action-btn primary"
        (click)="onDownload()"
        [disabled]="loading()"
      >
        Download
      </button>
    </div>
  `,
})
export class ExportServicePointAttributesModalComponent {
  private readonly activeModal = inject(NgbActiveModal)
  private readonly filterService = inject(FilterService)
  private readonly servicePointManagementService = inject(ServicePointManagementService)

  protected readonly loading = signal(false)
  protected readonly filterGroup = signal('')
  protected readonly filtersToShow = signal<readonly string[]>([])

  async init(filterGroup: string, filtersToShow: string[]) {
    this.filterGroup.set(filterGroup)
    this.filtersToShow.set(filtersToShow)
  }

  async onDownload() {
    this.loading.set(true)
    await firstValueFrom(this.filterService.asParams(this.filterGroup())
      .pipe(
        switchMap((params) =>
          this.servicePointManagementService.exportAttributes(
            params.filter(p => this.filtersToShow().includes(p.name)),
          )),
        tap(() => {
          this.loading.set(false)
          this.activeModal.dismiss()
        }),
      ))
  } 

  onCancel() {
    this.activeModal.dismiss()
  }
}
